cv.DonationsRowEmptyView = Marionette.LayoutView.extend({
  className: 'row-empty',
  template: cv.Templates['donations/row_empty'],

  events : {
  },

  templateHelpers: function(){
    return {
      project_url : cv.project.get('url')
    };
  },

  initialize: function(options){
    console.log('DonationsRowEmptyView initialized');
  },

  onAttach: function(){
  }
});
